export default __webpack_public_path__ + "static/media/airMonitor.34d34a68.png";